import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogTitle,
    TextField,
    withStyles,
    DialogContent,
    List,
    Chip,
    Tabs,
    Tab,
    InputLabel,
    Typography,
    Paper,
} from 'material-ui';
import DropzoneImageField from '../../../../components/fields/field_dropzone_image';
import ImageDetailsCropDialog from '../image_details_crop';
import ImageDetailsMetaDialog from '../image_details_meta';
import {TabContainer} from '../../../../components/tab/tab_container';
import PagePicker from '../../../page-picker/page_picker';
import SimpleEditor from '../../../../components/editor/simple_editor';
import {b64toBlob, toDataUrl} from '../../../../components/helpers/helpers';
import {styles} from '../../style/staff_section';

class ValuePropositionSectionEditPopup extends React.Component {
    state = {
        selectedValuePropositionIndex: 0,
    };

    handleTabChange = (event, value) => {
        this.setState({
            selectedValuePropositionIndex: value,
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            expandedImageSettings: false,
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageToView: null,
            src: null,
            cropResult: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        };
    }

    onImageClick = (index, image) => {
        if (image.new) {
            this.updateLocalStateWithImage(
                image,
                index,
                this.props.valuePropositions
            );
            let croppedImage = this.props.valuePropositions[index].image
                .croppedImage;
            let croppedImageThumb = this.props.valuePropositions[index].image
                .croppedImageThumb;
            if (croppedImage) {
                toDataUrl(croppedImage, (cropUrl) => {
                    this.setCroppedImageInState(cropUrl);
                });
            }
            if (croppedImageThumb) {
                toDataUrl(croppedImageThumb, (cropUrl) => {
                    this.setThumbCroppedImageInState(cropUrl);
                });
            }
        } else {
            const {
                title,
                alt,
                name,
                description,
                link,
            } = this.props.valuePropositions[index].image;
            this.setState({
                touched: true,
                openCropPopup: true,
                openImageMetaPopup: true,
                imageToCrop: null,
                imageToView: image,
                imageMeta: {
                    title,
                    alt,
                    name,
                    description,
                    link,
                },
            });
        }
    };

    updateLocalStateWithImage(image, index, valuePropositions) {
        const {title, alt, name, description, link} = valuePropositions[
            index
        ].image;
        this.setState({
            touched: true,
            openCropPopup: true,
            imageToCrop: image,
            imageMeta: {
                title,
                alt,
                name,
                description,
                link,
            },
        });
    }

    updateState() {
        this.setState({
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            src: null,
            cropResult: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        });
    }

    setCroppedImageInState(croppedImage) {
        this.setState({
            cropResult: croppedImage,
        });
    }

    render() {
        let {
            title,
            classes,
            onHandleSubmit,
            onHandleClose,
            closePagePicker,
            onUpdateTitleField,
            valuePropositions,
            onCropImage,
            onCropThumbImage,
            onImageMetaUpdate,
        } = this.props;

        let {selectedValuePropositionIndex} = this.state;

        if (
            !selectedValuePropositionIndex ||
            typeof selectedValuePropositionIndex === 'undefined'
        ) {
            selectedValuePropositionIndex = 0;
        }

        let selectedValueProposition = null;
        if (valuePropositions) {
            selectedValueProposition =
                valuePropositions[selectedValuePropositionIndex];
        }

        let selectedValuePropositionTitle = '';
        if (
            selectedValueProposition &&
            typeof selectedValueProposition.title !== 'undefined'
        ) {
            selectedValuePropositionTitle = selectedValueProposition.title;
        }

        let selectedValuePropositionBody = '';
        if (
            selectedValueProposition &&
            typeof selectedValueProposition.body !== 'undefined'
        ) {
            selectedValuePropositionBody = selectedValueProposition.body;
        }

        let selectedValuePropositionPageTitle = 'None Selected';
        if (
            selectedValueProposition &&
            typeof selectedValueProposition.page !== 'undefined' &&
            selectedValueProposition.page &&
            typeof selectedValueProposition.page.title !== 'undefined'
        ) {
            selectedValuePropositionPageTitle =
                selectedValueProposition.page.title;
        }

        let selectedValuePropositionButtonText = '';
        if (
            selectedValueProposition &&
            typeof selectedValueProposition.button_text !== 'undefined'
        ) {
            selectedValuePropositionButtonText =
                selectedValueProposition.button_text;
        }

        let selectedValuePropositionImage = null;
        if (
            selectedValueProposition &&
            typeof selectedValueProposition.image !== 'undefined'
        ) {
            selectedValuePropositionImage = selectedValueProposition.image;
        }

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Value Proposition Section</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />

                    <Tabs
                        value={selectedValuePropositionIndex}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                    >
                        <Tab value={0} label="Value Proposition 1" />
                        <Tab value={1} label="Value Proposition 2" />
                        <Tab value={2} label="Value Proposition 3" />}
                    </Tabs>
                    <TabContainer>
                        <List component="nav">
                            <Chip
                                className={classes.sectionLinkToPageChip}
                                label={
                                    'Value Proposition Page *: ' +
                                    selectedValuePropositionPageTitle
                                }
                                onClick={this.props.openPagePicker}
                            />

                            <TextField
                                autoFocus
                                margin="dense"
                                id="button_text"
                                label="Button Text"
                                onChange={(event) => {
                                    this.props.updateValuePropositionButtonText(
                                        selectedValuePropositionIndex,
                                        event.target.value
                                    );
                                }}
                                fullWidth
                                value={selectedValuePropositionButtonText || ''}
                            />

                            <TextField
                                autoFocus
                                margin="dense"
                                id="title"
                                label="Title"
                                onChange={(event) => {
                                    this.props.updateValuePropositionTitle(
                                        selectedValuePropositionIndex,
                                        event.target.value
                                    );
                                }}
                                fullWidth
                                value={selectedValuePropositionTitle || ''}
                            />

                            <InputLabel className="simpleEditorLabelPages">
                                Body
                            </InputLabel>
                            <SimpleEditor
                                id={selectedValuePropositionIndex}
                                initialValue={
                                    selectedValuePropositionBody || ''
                                }
                                onChange={(htmlBody) => {
                                    this.props.updateValuePropositionBody(
                                        selectedValuePropositionIndex,
                                        htmlBody
                                    );
                                }}
                            />

                            <Typography
                                variant="subheading"
                                className={classes.imageUploadSubheadingText}
                            >
                                Value Proposition Image
                            </Typography>
                            <Paper elevation={1} style={{padding: 10}}>
                                <DropzoneImageField
                                    multiple={false}
                                    images={selectedValuePropositionImage}
                                    onImageDelete={(image) => {
                                        this.props.onDeleteImageField(
                                            image,
                                            selectedValuePropositionIndex
                                        );
                                    }}
                                    onImageClick={(image, index) => {
                                        this.onImageClick(
                                            selectedValuePropositionIndex,
                                            image
                                        );
                                    }}
                                    onImagesDrop={(image) => {
                                        this.props.onUpdateImageField(
                                            selectedValuePropositionIndex,
                                            image
                                        );
                                    }}
                                />

                                {selectedValuePropositionImage &&
                                    selectedValuePropositionImage.new &&
                                    !selectedValuePropositionImage.deleted && (
                                        <h4 className="errMsg">
                                            Once you have selected a Value
                                            Proposition Image please click on it
                                            in order to CROP it. Crop is
                                            mandatory!
                                        </h4>
                                    )}
                            </Paper>
                        </List>
                    </TabContainer>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>

                <PagePicker
                    open={this.props.sectionPagePickerPopupOpen}
                    handleClose={closePagePicker}
                    onPick={(pageId, pageTitle) => {
                        this.props.onPickSectionPage(
                            selectedValuePropositionIndex,
                            pageId,
                            pageTitle
                        );
                        closePagePicker();
                    }}
                    searchString={this.props.pageSearchCriteria}
                    onSearchPages={(event) => {
                        this.props.onSearchPages(
                            event.target.value,
                            this.props.siteId
                        );
                    }}
                    allPagesBySearchCriteria={
                        this.props.allPagesBySearchCriteria
                    }
                />

                <ImageDetailsMetaDialog
                    classes={this.props.classes}
                    open={this.state.openImageMetaPopup}
                    imageMeta={this.state.imageMeta}
                    image={this.state.imageToView}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    handleSubmit={() => {
                        onImageMetaUpdate(
                            selectedValuePropositionIndex,
                            this.state.imageMeta
                        );
                        this.updateState();
                    }}
                    handleCancel={() => {
                        this.updateState();
                    }}
                />

                <ImageDetailsCropDialog
                    cropResult={this.state.cropResult}
                    thumbCropResult={this.state.thumbCropResult}
                    imageToCrop={this.state.imageToCrop}
                    imageRatios={this.props.imageRatios}
                    open={this.state.openCropPopup}
                    imageMeta={this.state.imageMeta}
                    isHero={false}
                    displayAllRatios={false}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    setCropResult={(cropResult) => {
                        this.setState({
                            cropResult,
                        });
                    }}
                    setThumbCropResult={(thumbCropResult) => {
                        this.setState({
                            thumbCropResult,
                        });
                    }}
                    handleSubmit={() => {
                        if (this.state.cropResult) {
                            let imageObject = b64toBlob(this.state.cropResult);
                            const imageUrlBlob = URL.createObjectURL(
                                imageObject
                            );
                            onCropImage(
                                selectedValuePropositionIndex,
                                imageObject,
                                imageUrlBlob,
                                imageObject
                            );
                        }
                        if (this.state.thumbCropResult) {
                            let thumbImageObject = b64toBlob(
                                this.state.thumbCropResult
                            );
                            const imageThumbUrlBlob = URL.createObjectURL(
                                thumbImageObject
                            );
                            onCropThumbImage(
                                selectedValuePropositionIndex,
                                thumbImageObject,
                                imageThumbUrlBlob,
                                thumbImageObject
                            );
                        }
                        onImageMetaUpdate(
                            selectedValuePropositionIndex,
                            this.state.imageMeta
                        );
                        this.updateState();
                    }}
                    handleClose={() => {
                        this.updateState();
                    }}
                />
            </EditDialog>
        );
    }
}

export default withStyles(styles)(ValuePropositionSectionEditPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/value_proposition_section_edit.js